export default __webpack_public_path__ + "static/media/4.a15041e1.svg";